import { useMemo } from 'react';
import { useGetCustomService } from 'hooks/rest/useGetCustomService';
import { portfolioSelector, usePortfolioSelector } from 'domain/Portfolio';

export const useAllPortfolios = (clientId: number | string, language: string) => {
    const { data, isLoading: isSelectorLoading, error: selectorError } = usePortfolioSelector(portfolioSelector) as any;

    const { data: portfoliosResponse, isLoading: isPortfoliosLoading, error: portfoliosError } = useGetCustomService({
        service: 'portfolioManagement',
        api: 'getPortfolios',
        payload: { contactId: clientId, language },
        enabled: !isSelectorLoading && !selectorError && !!clientId,
        refetchOnWindowFocus: false,
    });

    const { filteredPortfoliosData, totalCategoryValue, portfolioTitle } = useMemo(() => {
        const allPortfolios = portfoliosResponse?.data || [];
        const { productId, title } = data || {};

        if (!productId || !allPortfolios.length) {
            return { filteredPortfoliosData: [], totalCategoryValue: 0, portfolioTitle: '' };
        }

        const filteredPortfolios = allPortfolios.filter((portfolio: any) => portfolio.Product.Id === productId);
        const totalCategory = filteredPortfolios.reduce((acc: number, portfolio: any) => acc + portfolio.CurrentValue, 0);

        return {
            filteredPortfoliosData: filteredPortfolios,
            totalCategoryValue: totalCategory,
            portfolioTitle: title || '',
        };
    }, [portfoliosResponse?.data, data?.productId, data?.title]);

    return {
        isLoading: isSelectorLoading || isPortfoliosLoading,
        error: selectorError || portfoliosError,
        data: filteredPortfoliosData,
        totalCategoryValue,
        totalValue: totalCategoryValue * 1.35,
        portfolioTitle,
    };
};
